const SOCIAL_MEDIA_ITEMS = [
  {
    name: 'facebook',
    icon: 'si-facebook',
    href: 'https://www.facebook.com/spotmemx'
  },
  {
    name: 'instagram',
    icon: 'si-instagram',
    href: 'https://www.instagram.com/spotme.mx'
  },
  {
    name: 'youtube',
    icon: 'si-youtube',
    href: 'https://www.youtube.com/@spotme_mx'
  },
  {
    name: 'linkedin',
    icon: 'si-linkedin',
    href: 'https://www.linkedin.com/company/spotmemx'
  },
  {
    name: 'tiktok',
    icon: 'si-tiktok',
    href: 'https://www.tiktok.com/@spotme.mx'
  }
]

interface SocialMediaIconsProps {
  /** Text-colour class; the hairline circle and focus ring derive from it. */
  primaryColor: string
  secondaryColor?: string
  justifyContent: string
}

/**
 * Hairline-circle social links. Rendered on light (`text-ink-700`) and dark
 * (`text-white-500`) surfaces, so every chrome colour is `currentColor`.
 * Each anchor is a 44px tap target around a 36px visible circle; the row
 * bleeds 4px each side so the circles, not the hit areas, align with the
 * surrounding text edge. `flex-wrap` keeps it inside narrow cards at 320px.
 */
const SocialMediaIcons = ({
  primaryColor,
  justifyContent
}: SocialMediaIconsProps) => {
  const justifyClass =
    justifyContent === 'center' ? 'justify-center' : 'justify-start'

  return (
    <div className={`-mx-1 flex flex-wrap ${justifyClass}`}>
      {SOCIAL_MEDIA_ITEMS.map((item) => (
        <a
          key={item.name}
          href={item.href}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={`Follow us on ${item.name}`}
          className={`group flex size-11 items-center justify-center rounded-full focus-visible:outline-2 focus-visible:-outline-offset-2 focus-visible:outline-current ${primaryColor}`}
        >
          <span className="flex size-9 items-center justify-center rounded-full border border-current/25 transition-[border-color,transform] duration-200 group-hover:border-current motion-safe:group-hover:-translate-y-0.5 motion-reduce:transition-none">
            <i aria-hidden="true" className={`si ${item.icon} text-lg`} />
          </span>
        </a>
      ))}
    </div>
  )
}

export default SocialMediaIcons
